module.exports = {
  siteTitle: 'El Ninja que se perdió | Versión GForms', // <title>
  manifestName: 'Espía que se perdió',
  manifestShortName: 'Espía', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/images/favicon.png',
  pathPrefix: `/gatsby-starter-multiverse/`, // This path is subpath of your hosting https://domain/portfolio
  heading: 'El espía que se perdió',
  subHeading: 'Versión online',
  // social
  socialLinks: [],
};
